















import Vue from 'vue';
import massVuex from '../../vuex/common';
import moment from 'moment';

export default Vue.extend({
  mixins: [massVuex],
  computed: {
    showTips(): boolean {
      if (this.account && this.account.crmCreate && moment(this.account.crmCreate) > moment().subtract(48, 'hours')) {
        return true;
      } else {
        return false;
      }
    },
  },
});
